import Fetch from '@/hooks/fetch';
import actions from '../constants';

export default {
  useRequestUserSubscriptions: ({ category, code }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_REQUEST_USER_SUBSCRIPTIONS,
    readStatus,
    { category, code },
  ),
};
